import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"
import { AuthProvider, AuthContext } from "./context/AuthContext"
import { NotificationProvider } from "./context/NotificationContext"
import { useContext } from "react"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import SignIn from "./pages/SignIn"
import Profile from "./pages/Profile"
import Products from "./pages/Products"
import CreateOrder from "./pages/CreateOrder"
import OrdersList from "./pages/OrderList"
import AddCourierService from "./pages/AddCourierService"
import Payment from "./pages/Payment"
import NewOrders from "./pages/NewOrders"
import PendingPackedOrders from "./pages/PendingPackedOrders"
import PaymentHistory from "./pages/PaymentHistory "
import AddRoles from "./pages/AddRoles"
import AddUsers from "./pages/AddUsers"
import PrivateRoute from "./components/PrivateRoute"
import MainLayout from "./components/MainLayout"
import Summary from "./pages/Summary"
import WebPendingConfirm from "./components/WebPendingConfirm"
import HeatMapDashboard from "./pages/Dashboards/OrderHeatMap"
import StoreInsights from "./pages/Dashboards/StoreInsights"
import FinanceDashboard from "./pages/Dashboards/FinanceDashboard"
import LowStockDashboard from "./pages/Dashboards/LowStockDashboard"

const FullPageLoader = () => (
  <div className="w-full h-screen flex items-center justify-center">
    <span className="text-xl font-semibold">Loading...</span>
  </div>
)

function AppRoutes() {
  const { isAuthenticated, loading } = useContext(AuthContext)

  if (loading) return <FullPageLoader />

  return (
    <Routes>
      <Route
        path="/signin"
        element={
          isAuthenticated ? <Navigate to="/summary" replace /> : <SignIn />
        }
      />

      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <MainLayout>
              <Profile />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/products"
        element={
          <PrivateRoute>
            <MainLayout>
              <Products />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/create-order"
        element={
          <PrivateRoute>
            <MainLayout>
              <CreateOrder />
            </MainLayout>
          </PrivateRoute>
        }
      />


      <Route
        path="/all-orders"
        element={
          <PrivateRoute>
            <MainLayout>
              <OrdersList />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/add-courier"
        element={
          <PrivateRoute>
            <MainLayout>
              <AddCourierService />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/new-orders"
        element={
          <PrivateRoute>
            <MainLayout>
              <NewOrders />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/web-pending-confirm-orders"
        element={
          <PrivateRoute>
            <MainLayout>
              <WebPendingConfirm />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/pending-packed"
        element={
          <PrivateRoute>
            <MainLayout>
              <PendingPackedOrders />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/payment"
        element={
          <PrivateRoute>
            <MainLayout>
              <Payment />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/payment-history"
        element={
          <PrivateRoute>
            <MainLayout>
              <PaymentHistory />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/add-roles"
        element={
          <PrivateRoute>
            <MainLayout>
              <AddRoles />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/add-users"
        element={
          <PrivateRoute>
            <MainLayout>
              <AddUsers />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/summary"
        element={
          <PrivateRoute>
            <MainLayout>
              <Summary />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/order-heatmap"
        element={
          <PrivateRoute>
            <MainLayout>
              <HeatMapDashboard />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/store-insights"
        element={
          <PrivateRoute>
            <MainLayout>
              <StoreInsights />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/finance"
        element={
          <PrivateRoute>
            <MainLayout>
              <FinanceDashboard />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/low-stock"
        element={
          <PrivateRoute>
            <MainLayout>
              <LowStockDashboard />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  )
}

function InnerApp() {
  const { loading } = useContext(AuthContext)

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <NotificationProvider>
        {loading ? <FullPageLoader /> : <AppRoutes />}
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          className="!fixed !top-4 !right-10 !z-[99999]"
          toastClassName="!bg-gray-900/95 !backdrop-blur-md !border !border-gray-800 !rounded-xl !shadow-2xl !p-0 !mb-4 !min-w-[350px] relative overflow-hidden"
          bodyClassName="!p-0 !m-0 !w-full"
          icon={false}
          closeButton={false}
        />
      </NotificationProvider>
    </Router>
  )
}

function App() {
  return (
    <AuthProvider>
      <InnerApp />
    </AuthProvider>
  )
}

export default App
